import events from '../../../actions/event-names';
import Config from '../../../config';
import { showError, showSuccess } from '../../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    exerciseList: [],
    isDetailsFetched: false,
    exerciseDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_EXERCISE_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.exerciseList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_EXERCISE_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            exerciseList: [...state.exerciseList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_EXERCISE_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_EXERCISE_DETAILS}_PENDING`: {
        return {
            ...state,
            exerciseDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_EXERCISE_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_EXERCISE_DETAILS}_FULFILLED`: {
        return {
            ...state,
            exerciseDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_EXERCISE_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_EXERCISE_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_EXERCISE_DETAILS}_PENDING`: {
        return {
            ...state,
            saveexerciseDetails: 'PENDING',
        };
    }
    case `${events.SAVE_EXERCISE_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_EXERCISE_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saveexerciseDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_EXERCISE_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_EXERCISE_DETAILS}_REJECTED`: {
        return {
            ...state,
            saveexerciseDetails: 'REJECTED',
        };
    }

  

    case `${events.ADD_NEW_EXERCISE}_PENDING`: {
        return {
            ...state,
            isNewexerciseAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_EXERCISE}_FULFILLED`: {
        showSuccess("New exercise added successfully")
        return {
            ...state,
            isNewexerciseAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_EXERCISE}_REJECTED`: {
        return {
            ...state,
            isNewexerciseAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_EXERCISE}_PENDING`: {
        return {
            ...state,
            isexerciseDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_EXERCISE}_FULFILLED`: {
        showSuccess("Exercise deleted successfully")
        return {
            ...state,
            isexerciseDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_EXERCISE}_REJECTED`: {
        return {
            ...state,
            isexerciseDeleted: 'REJECTED',
        };
    }
    

    






    default:
        return state;
    }
}
